export default {
    organizations(state) {
        return state.agenciesAndAdvertisers;
    },
    searchString(state) {
        return state.nameOrDescription;
    },
    creativeCode(state) {
        return state.creativeCode;
    },
    pageNumber(state) {
        return state.pageNumber;
    },
    pageSize(state) {
        return state.pageSize;
    }
}